module.exports = __webpack_public_path__ + "img/7.4b17c7a6.jpg";